import { render, staticRenderFns } from "./coachIdentityManage.vue?vue&type=template&id=f0efb598&scoped=true&"
import script from "./coachIdentityManage.vue?vue&type=script&lang=js&"
export * from "./coachIdentityManage.vue?vue&type=script&lang=js&"
import style0 from "./coachIdentityManage.vue?vue&type=style&index=0&id=f0efb598&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0efb598",
  null
  
)

export default component.exports